import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'App/store';
import { getPriceTables } from 'domains/Customers/PriceTables/priceTablesSlice';
import {
  getPriceTablesData,
  getPriceTablesStatus,
} from 'domains/Customers/PriceTables/priceTablesSlice/priceTablesSelectors';

export default function usePriceTables() {
  const dispatch = useAppDispatch();

  const priceTablesData = useSelector(getPriceTablesData);
  const priceTablesStatus = useSelector(getPriceTablesStatus);

  const fetchPriceTables = useCallback(
    () => dispatch(getPriceTables()),
    [dispatch],
  );

  return {
    priceTablesData,
    priceTablesStatus,
    fetchPriceTables,
  };
}
